import $ from 'jquery'

// Toggle visibility of "Please specify" text areas based on "Other (please specify)" checkbox state
$(document).on('turbolinks:load', function () {
  // Define all checkbox + notes field pairs that need toggle behavior
  // These are the field keys without the form prefix
  const otherCheckboxPairs = [
    // V1 Annual Report
    { checkbox: 'ar_v1_q3_4_d', notes: 'ar_v1_q3_4_notes' },
    { checkbox: 'ar_v1_q4_7_a_v', notes: 'ar_v1_q4_7_notes' },
    { checkbox: 'ar_v1_q5_2_f', notes: 'ar_v1_q5_2_f_notes' },
    { checkbox: 'ar_v1_q6_1_h', notes: 'ar_v1_q6_1_h_notes' },
    { checkbox: 'ar_v1_q6_2_c_v', notes: 'ar_v1_q6_2_c_v_notes' },
    { checkbox: 'ar_v1_q7_1_e', notes: 'ar_v1_q7_1_e_notes' },
    // V2
    { checkbox: 'ar_v2_q7_1_d', notes: 'ar_v2_q7_1_d_notes' },
    // V3
    { checkbox: 'ar_v3_q4_7_a_v', notes: 'ar_v3_q4_7_a_notes' },
    { checkbox: 'ar_v3_q6_1_h', notes: 'ar_v3_q6_1_notes' },
    { checkbox: 'ar_v3_q6_2_c_v', notes: 'ar_v3_q6_2_c_notes' },
    { checkbox: 'ar_v3_q7_1_e', notes: 'ar_v3_q7_1_notes' },
    { checkbox: 'ar_v3_q7_1_e', notes: 'ar_v3_q7_1_e_notes' },
  ]

  // Form prefixes used in different contexts
  const formPrefixes = ['annual_report_', 'covenant_action_plan_']

  otherCheckboxPairs.forEach(function (pair) {
    formPrefixes.forEach(function (prefix) {
      const checkbox = $(`#${prefix}${pair.checkbox}`)
      const notesField = $(`#${prefix}${pair.notes}`)

      if (checkbox.length && notesField.length) {
        // Set initial state
        toggleNotesField(checkbox, notesField)

        // Toggle on change
        checkbox.on('change', function () {
          toggleNotesField($(this), notesField)
        })
      }
    })
  })
})

function toggleNotesField(checkbox, notesField) {
  const formGroup = notesField.parents('.form-group')

  const checked = checkbox.prop('checked')
  const disabled = notesField.prop('disabled')
  const hasValue = (notesField.val() || '').trim().length > 0

  // Show notes when:
  // - checkbox is checked, OR
  // - notes already have a value (e.g. inherited / prefilled), OR
  // - notes are disabled (e.g. inherited and not editable)
  if (checked || hasValue || disabled) {
    formGroup.removeClass('!none')
    return
  }

  // Only clear when the user can actually edit the field
  if (!disabled) {
    notesField.val('')
  }
  formGroup.addClass('!none')
}
